/**
 * Check if a color is light or dark
 * @param {string} color
 * @returns {boolean}
 */
export function isColorLight(color) {
  // Remove the hash if present
  color = color.replace('#', '')

  // Convert shorthand colors to full form (e.g., "03F" -> "0033FF")
  if (color.length === 3) {
    color = color
      .split('')
      .map((char) => char + char)
      .join('')
  }

  const r = parseInt(color.substr(0, 2), 16)
  const g = parseInt(color.substr(2, 2), 16)
  const b = parseInt(color.substr(4, 2), 16)

  // Calculate the brightness of the color
  const brightness = (r * 299 + g * 587 + b * 114) / 1000

  // Return true if the color is light, false otherwise
  return brightness > 155
}
